import styled, { css } from "styled-components"
import { FaCaretUp, FaCaretDown } from "react-icons/fa"

const MarketName = styled.div`
    width: 15%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ${props => props.theme.english && css`
        border-right: 1px solid ${props => props.theme.primary};
    `}
    ${props => !props.theme.english && css`
        border-left: 1px solid ${props => props.theme.primary};
    `}
    padding: 0 20px;
`

const OrderBar = styled.div`
    width: ${props => `${props.width * 100}%`};
    height: 8px;
    background-color: ${props => props.type === "buy" ? props.theme.mainGreen : props.theme.mainRed};
`


const ArrowUp = styled(FaCaretUp)`
  color: ${props => props.theme.color};
  margin: -3px 2px 0 2px;
`

const ArrowDown = styled(FaCaretDown)`
  color: ${props => props.theme.color};
  margin: -3px 2px 0 2px;
`


export {
    MarketName,
    OrderBar,
    ArrowUp,
    ArrowDown
}